import { render, staticRenderFns } from "./DeleteCompany.vue?vue&type=template&id=dfb460ec&scoped=true"
import script from "./DeleteCompany.vue?vue&type=script&lang=js"
export * from "./DeleteCompany.vue?vue&type=script&lang=js"
import style0 from "./DeleteCompany.vue?vue&type=style&index=0&id=dfb460ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb460ec",
  null
  
)

export default component.exports